module.exports = __webpack_public_path__ + "static/media/checklist-date.6d4c4478.png";